@if (loading) {
  <div class="loading-state">
    <div class="detail-title-row">
      <button type="button" class="back-button" (click)="requestBackToJobs()" aria-label="Back to jobs"></button>
      <div class="title-skeleton"></div>
    </div>
    <div class="detail-card skeleton-panel"></div>
  </div>
} @else if (job) {
  @if (fetchingRemoteJob) {
    <div class="processing-backdrop" role="status" aria-live="polite" aria-label="Loading job details">
      <section class="processing-panel">
        <span class="processing-spinner" aria-hidden="true"></span>
        <h2>Loading Job Details</h2>
        <p>Fetching job details and filling the property fields.</p>
      </section>
    </div>
  }

  <section class="detail-title-row">
    <div class="title-group">
      <button type="button" class="back-button" (click)="requestBackToJobs()" aria-label="Back to jobs"></button>
      <h1>{{ job.address || 'New Job' }}{{ job.jobNumber ? ' — TOPS Job #' + job.jobNumber : '' }}</h1>
    </div>
    <div class="header-actions">
      <button type="button" class="action-button primary-action" (click)="saveAll()" [disabled]="saving || isJobAddressMissing || hasDuplicateNames()"><svg class="save-svg-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M21 7V21H3V3H17L21 7ZM19 7.85L16.15 5H5V19H19V7.85ZM12 18C12.8333 18 13.5417 17.7083 14.125 17.125C14.7083 16.5417 15 15.8333 15 15C15 14.1667 14.7083 13.4583 14.125 12.875C13.5417 12.2917 12.8333 12 12 12C11.1667 12 10.4583 12.2917 9.875 12.875C9.29167 13.4583 9 14.1667 9 15C9 15.8333 9.29167 16.5417 9.875 17.125C10.4583 17.7083 11.1667 18 12 18ZM6 10H15V6H6V10ZM5 7.85V19V5V7.85Z" /></svg><span>{{ saving ? 'Saving...' : 'Save' }}</span></button>
      <button type="button" class="action-button sync-action" (click)="saveAndSync()" [disabled]="!isOnline || saving || syncing || isJobAddressMissing || hasDuplicateNames()"><svg class="sync-svg-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18.5H6.5A4.5 4.5 0 0 1 6 9.53 6.8 6.8 0 0 1 19.5 11H20a3.5 3.5 0 0 1 0 7h-1"/><path d="M12 11v9"/><path d="m8.5 16.5 3.5 3.5 3.5-3.5"/></svg><span>{{ syncing ? 'Syncing...' : 'Sync' }}</span></button>
      <button type="button" class="action-button primary-action" (click)="openCameraPopout()"><svg class="camera-svg-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 16.5C13.25 16.5 14.3127 16.0627 15.188 15.188C16.0627 14.3127 16.5 13.25 16.5 12C16.5 10.75 16.0627 9.6873 15.188 8.812C14.3127 7.9373 13.25 7.5 12 7.5C10.75 7.5 9.6873 7.9373 8.812 8.812C7.9373 9.6873 7.5 10.75 7.5 12C7.5 13.25 7.9373 14.3127 8.812 15.188C9.6873 16.0627 10.75 16.5 12 16.5ZM10.9 10.9L11.55 9.5C11.6333 9.3167 11.7833 9.225 12 9.225C12.2167 9.225 12.3667 9.3167 12.45 9.5L13.1 10.9L14.5 11.55C14.6833 11.6333 14.775 11.7833 14.775 12C14.775 12.2167 14.6833 12.3667 14.5 12.45L13.1 13.1L12.45 14.5C12.3667 14.6833 12.2167 14.775 12 14.775C11.7833 14.775 11.6333 14.6833 11.55 14.5L10.9 13.1L9.5 12.45C9.3167 12.3667 9.225 12.2167 9.225 12C9.225 11.7833 9.3167 11.6333 9.5 11.55L10.9 10.9ZM4 20C3.45 20 2.9793 19.8043 2.588 19.413C2.196 19.021 2 18.55 2 18V6C2 5.45 2.196 4.9793 2.588 4.588C2.9793 4.196 3.45 4 4 4H7.15L8.4 2.65C8.5833 2.4333 8.804 2.2707 9.062 2.162C9.3207 2.054 9.5917 2 9.875 2H14.125C14.4083 2 14.6793 2.054 14.938 2.162C15.196 2.2707 15.4167 2.4333 15.6 2.65L16.85 4H20C20.55 4 21.021 4.196 21.413 4.588C21.8043 4.9793 22 5.45 22 6V18C22 18.55 21.8043 19.021 21.413 19.413C21.021 19.8043 20.55 20 20 20H4ZM20 18V6H4V18H20Z" /></svg><span>Camera</span></button>
      <button type="button" class="action-button primary-action" (click)="openManagePhotos()" [disabled]="saving || hasDuplicateNames()"><svg class="manage-photos-svg-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M1 21V6H3V19H20V21H1ZM5 17V2H12L14 4H23V17H5ZM7 15H21V6H13.175L11.175 4H7V15Z" /></svg><span>Manage Photos</span></button>
    </div>
  </section>

  @if (unsavedBackPromptOpen) {
    <div class="modal-backdrop unsaved-backdrop" role="presentation">
      <section class="unsaved-changes-panel" role="dialog" aria-modal="true" aria-labelledby="unsavedChangesTitle" aria-describedby="unsavedChangesMessage">
        <h2 id="unsavedChangesTitle">Unsaved Changes</h2>
        <p id="unsavedChangesMessage">You have unsaved changes on this inspection. If you leave now, your changes will be lost. Would you like to go back and save them first?</p>
        <footer class="unsaved-actions">
          <button type="button" class="unsaved-discard-button" (click)="proceedBackToJobsWithoutSaving()">Proceed without saving</button>
          <button type="button" class="unsaved-save-button" (click)="cancelBackToJobs()" autofocus>Go back and save</button>
        </footer>
      </section>
    </div>
  }

  @if (deleteDwellingPrompt.open) {
    <div class="modal-backdrop unsaved-backdrop" role="presentation">
      <section class="unsaved-changes-panel" role="dialog" aria-modal="true" aria-labelledby="deleteDwellingTitle" aria-describedby="deleteDwellingMessage">
        <h2 id="deleteDwellingTitle">Delete Dwelling</h2>
        <p id="deleteDwellingMessage">The changes for {{ deleteDwellingPrompt.buildingName }} will be deleted from this inspection. Are you sure you want to continue?</p>
        <footer class="unsaved-actions">
          <button type="button" class="unsaved-discard-button" (click)="confirmRemoveBuilding()">Delete dwelling</button>
          <button type="button" class="unsaved-save-button" (click)="cancelRemoveBuilding()" autofocus>Cancel</button>
        </footer>
      </section>
    </div>
  }

  @if (syncChoiceOpen) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel sync-choice-panel" role="dialog" aria-modal="true" aria-label="Choose sync content">
        <header class="modal-header">
          <h2>Upload Job</h2>
        </header>
        <p class="sync-job-line">Job #{{ job.jobNumber || job.id }} -- {{ job.address }}</p>
        <p class="sync-review-summary">Choose what to send to the TOPS.</p>

        <div class="sync-choice-options">
          <label class="sync-choice-option">
            <input type="radio" name="syncContentMode" value="fields-and-photos" [(ngModel)]="syncContentMode" />
            <span><strong>Field Values and photos</strong><small>Upload property details and notes , plus  {{ syncPhotoCount }} attached to this job.</small></span>
          </label>
          <label class="sync-choice-option">
            <input type="radio" name="syncContentMode" value="fields-only" [(ngModel)]="syncContentMode" />
            <span><strong>Field values only</strong><small>Upload property details and notes. Photos stay on this device.</small></span>
          </label>
          <label class="sync-choice-option">
            <input type="radio" name="syncContentMode" value="photos-only" [(ngModel)]="syncContentMode" />
            <span><strong>Photos only</strong><small>Upload {{ syncPhotoCount }} photos only. Field values stay on this device.</small></span>
          </label>
        </div>

        <footer class="modal-footer">
          <button type="button" class="btn secondary" (click)="closeSyncChoice()" [disabled]="syncing">Cancel</button>
          <button type="button" class="btn primary" (click)="startSync()" [disabled]="syncing"><svg class="sync-svg-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18.5H6.5A4.5 4.5 0 0 1 6 9.53 6.8 6.8 0 0 1 19.5 11H20a3.5 3.5 0 0 1 0 7h-1"/><path d="M12 20v-9"/><path d="m8.5 14.5 3.5-3.5 3.5 3.5"/></svg><span>{{ syncing ? 'Starting...' : 'Start Upload' }}</span></button>
        </footer>
      </section>
    </div>
  }

  @if (syncReviewOpen && syncDraft) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel sync-review-panel" role="dialog" aria-modal="true" aria-label="Review sync conflicts">
        <header class="modal-header">
          <h2>Resolve {{ syncConflicts.length }} Conflict(s)</h2>
        </header>
        <p class="sync-review-summary">These fields differ between this device and the server. Pick a value for each.</p>

        <div class="conflict-list">
          @for (conflict of syncConflicts; track conflict.path) {
            <section class="conflict-row">
              <header class="conflict-heading">
                <h3>{{ conflict.label }}</h3>
              </header>
              <div class="conflict-values">
                <label class="conflict-choice" [class.selected]="conflict.selected === 'server' && !isCustomConflictActive(conflict)" (pointerdown)="selectConflictValue(conflict, 'server')" (click)="selectConflictValue(conflict, 'server')" (keydown.enter)="selectConflictValue(conflict, 'server')" (keydown.space)="selectConflictValue(conflict, 'server')" tabindex="0">
                  <input type="radio" value="server" [(ngModel)]="conflict.selected" tabindex="-1" />
                  <span>TOPS Data</span>
                  @if (conflict.valueKind === 'image' && imageSource(conflict.serverValue); as source) {
                    <img class="conflict-image" [src]="source" alt="Server image" />
                  } @else {
                    <pre>{{ valueText(conflict.serverValue) }}</pre>
                  }
                </label>
                <label class="conflict-choice" [class.selected]="conflict.selected === 'local' && !isCustomConflictActive(conflict)" (pointerdown)="selectConflictValue(conflict, 'local')" (click)="selectConflictValue(conflict, 'local')" (keydown.enter)="selectConflictValue(conflict, 'local')" (keydown.space)="selectConflictValue(conflict, 'local')" tabindex="0">
                  <input type="radio" value="local" [(ngModel)]="conflict.selected" tabindex="-1" />
                  <span>TOPS Offline Data</span>
                  @if (conflict.valueKind === 'image' && imageSource(conflict.localValue); as source) {
                    <img class="conflict-image" [src]="source" alt="This device image" />
                  } @else {
                    <pre>{{ valueText(conflict.localValue) }}</pre>
                  }
                </label>
              </div>
              <label class="conflict-custom-value" [class.selected]="isCustomConflictActive(conflict)">
                <span>Custom Data (overrides both)</span>
                <input type="text" [(ngModel)]="conflict.customValue" (focus)="focusCustomConflict(conflict)" (blur)="blurCustomConflict(conflict)" placeholder="Type a combined or adjusted value..." />
              </label>
            </section>
          }
        </div>

        <footer class="modal-footer">
          <button type="button" class="btn secondary" (click)="closeSyncReview()" [disabled]="syncing">Cancel</button>
          <button type="button" class="btn primary" (click)="confirmJobSync()" [disabled]="syncing">{{ syncing ? 'Syncing...' : 'Save Changes' }}</button>
        </footer>
      </section>
    </div>
  }

  @if (showCameraModal) {
    <div class="camera-modal-backdrop" role="presentation">
      <section class="camera-modal-panel" role="dialog" aria-modal="true" aria-label="Camera capture">
        <app-camera-popout
          [jobIdInput]="jobId"
          [modalMode]="true"
          [initialImageName]="cameraInitialImageName"
          [allowBlankImageName]="cameraAllowBlankImageName"
          (closed)="closeCameraModal()" />
      </section>
    </div>
  }

  @if (syncSuccessOpen) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel sync-success-panel" role="dialog" aria-modal="true" aria-label="Sync completed">
        <button type="button" class="sync-success-close" aria-label="Close" (click)="closeSyncSuccess()">&times;</button>
        <div class="sync-success-check" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <div class="sync-success-content">
          <h2>Job : #{{ job.jobNumber || job.id }}</h2>
          <p class="sync-success-address">{{ job.address }}</p>
          <p class="sync-success-message">All fields are in sync.</p>
        </div>
        <footer class="modal-footer sync-success-footer">
          <button type="button" class="btn primary" (click)="closeSyncSuccess()">Done</button>
        </footer>
      </section>
    </div>
  }

  <form [formGroup]="form" class="detail-card">
    <div class="copy-mode-row">
      <label class="copy-toggle">
        <span>Copy Mode</span>
        <input type="checkbox" [(ngModel)]="isCopyMode" [ngModelOptions]="{ standalone: true }" />
        <span class="toggle-track" aria-hidden="true"></span>
      </label>
    </div>

    <nav class="tabs" aria-label="Property form tabs">
      @for (tab of tabs; track tab.id) {
        <button
          type="button"
          [class.active]="activeTab === tab.id"
          [class.disabled]="isTabDisabled(tab.id)"
          [disabled]="isTabDisabled(tab.id)"
          [attr.aria-disabled]="isTabDisabled(tab.id)"
          (click)="setActiveTab(tab.id)">{{ tab.label }}</button>
      }
    </nav>

    @if (activeTab === 'general') {
      <section class="tab-panel">
        <h2>Job Information</h2>
        <div class="job-info-grid">
          <label>
            <span>TOPS Job Number</span>
            <div class="job-number-lookup-row">
              <input
                [(ngModel)]="job.jobNumber"
                [ngModelOptions]="{ standalone: true }"
                readonly
                aria-readonly="true" />
              @if (fetchingRemoteJob) {
                <span class="job-number-lookup-status">Loading</span>
              }
            </div>
          </label>
          <label>
            <span>Address<span class="required">*</span></span>
            <input [(ngModel)]="job.address" [ngModelOptions]="{ standalone: true }" required readonly aria-readonly="true" />
            @if (isJobAddressMissing) {
              <small class="field-error">Address is required.</small>
            }
          </label>
          <label>
            <span>Report Type</span>
            <select [ngModel]="selectedReportType" [ngModelOptions]="{ standalone: true }" disabled>
              <option value="">Select report type</option>
              @for (reportType of reportTypeOptions; track reportType) {
                <option [value]="reportType">{{ reportType }}</option>
              }
            </select>
            @if (isReportTypeMissing) {
              <small class="field-error">Please select a report type.</small>
            }
          </label>
          <label>
            <span>Valuation Type</span>
            <select formControlName="valuationType" (change)="setValuationType(form.controls.valuationType.value || '')">
              <option value="">Select valuation type</option>
              @for (option of valuationTypes; track $index) {
                <option [value]="option.valuationTypeId">{{ option.valuationType }}</option>
              }
            </select>
          </label>
          <label>
            <span>Appointment</span>
            <div class="appointment-row">
              <input [ngModel]="displayAppointment()" [ngModelOptions]="{ standalone: true }" placeholder="Select appointment" readonly aria-readonly="true" (click)="openAppointmentPicker()" />
              <button type="button" class="icon-outline-button appointment-calendar-button" (click)="openAppointmentPicker()" aria-label="Open appointment calendar"><span class="calendar-icon" aria-hidden="true"></span></button>
            </div>
          </label>
        </div>
        <div class="section-divider"></div>
        <h2>Contact Details</h2>
        <h3 class="contact-details-heading">Client Name / Contact Details</h3>
        <div class="contact-details-grid">
          <label>
            <span>Company Name</span>
            <div class="copy-field-row">
              <input formControlName="clientCompanyName" readonly aria-readonly="true" />
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(form.controls.clientCompanyName.value)" aria-label="Copy company name"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
          <label>
            <span>Report Prepared For</span>
            <div class="copy-field-row">
              <input formControlName="clientReportPreparedFor" readonly aria-readonly="true" />
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(form.controls.clientReportPreparedFor.value)" aria-label="Copy report prepared for"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
          <label>
            <span>Contact Name</span>
            <div class="copy-field-row">
              <input formControlName="clientContactName" readonly aria-readonly="true" />
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(form.controls.clientContactName.value)" aria-label="Copy contact name"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
          <label>
            <span>Phone</span>
            <div class="copy-field-row">
              <input formControlName="clientPhone" readonly aria-readonly="true" />
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(form.controls.clientPhone.value)" aria-label="Copy phone"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
          <label>
            <span>Email</span>
            <div class="copy-field-row">
              <input formControlName="clientEmail" readonly aria-readonly="true" />
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(form.controls.clientEmail.value)" aria-label="Copy email"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
        </div>
      </section>
    }

    @if (activeTab === 'improvements' && !isReportTypeMissing) {
      <section class="tab-panel improvements-panel">
        <div class="section-heading">
          <h2>Dwellings</h2>
          @if (isMultiDwellingValuationType) {
            <button type="button" class="action-button primary-action" (click)="addBuilding()"><span class="plus-symbol" aria-hidden="true">+</span><span>Add Dwelling</span></button>
          }
        </div>
        @for (building of visibleBuildings; track building.id; let index = $index) {
          <article class="dwelling-accordion" [class.open]="activeBuildingId === building.id">
            <button type="button" class="dwelling-trigger" (click)="toggleBuilding(building.id  )">
              <span class="home-icon" aria-hidden="true"></span>
              <span>{{ building.name || 'Dwelling ' + (index + 1) }}</span>
              <span class="chevron-icon" aria-hidden="true"></span>
            </button>

            @if (activeBuildingId === building.id) {
              <div class="dwelling-content">
                <div class="dwelling-name-row">
                  <label>
                    <span>Dwelling Name</span>
                    <input [(ngModel)]="building.name" [ngModelOptions]="{ standalone: true }" placeholder="Dwelling name" (ngModelChange)="checkDuplicateName(building)"/>
                    
                    <div
                        class="error-text"
                        *ngIf="building.isDuplicate"
                    >
                       Please provide a unique dwelling name.
                    </div>  

                  </label>
                  @if (!isMainDwelling(building)) {
                    <button type="button" class="danger-button" (click)="requestRemoveBuilding(building)"><span class="trash-icon" aria-hidden="true"></span><span>Remove Dwelling</span></button>
                  }
                </div>

                <section class="dwelling-panel">
                  <div class="dwelling-panel-header">
                    <h3>External Description</h3>
                    @if (!isCopyMode) {
                      <button type="button" class="outline-button compact-button" (click)="openBuildingGroupOptions(building, externalBuildingFields)"><span class="button-icon list-icon" aria-hidden="true"></span><span>Quick Select</span></button>
                    }
                  </div>
                  <ng-container *ngTemplateOutlet="buildingFieldGrid; context: { building: building, fields: externalBuildingFields, gridClass: 'external-building-grid' }" />
                </section>

                <section class="dwelling-panel">
                  <div class="dwelling-panel-header">
                    <h3>Internal Description</h3>
                    @if (!isCopyMode) {
                      <button type="button" class="outline-button compact-button" (click)="openInternalDescriptionQuickChoice(building)"><span class="button-icon list-icon" aria-hidden="true"></span><span>Quick Select</span></button>
                    }
                  </div>
                  <div class="internal-building-columns">
                    <div class="internal-building-column">
                      <ng-container *ngTemplateOutlet="buildingFieldList; context: { building: building, fields: internalBuildingSummaryFields }" />
                    </div>
                    <div class="internal-building-column">
                      <ng-container *ngTemplateOutlet="buildingFieldList; context: { building: building, fields: internalBuildingTextFields }" />
                    </div>
                  </div>
                </section>

                <section class="dwelling-panel">
                  <div class="dwelling-panel-header">
                    <h3>Additional Dwelling Details</h3>
                  </div>
                  <div class="additional-details-grid">
                    <div class="additional-column">
                      <div class="floor-area-table">
                        <h4 class="floor-area-title">Floor Areas</h4>
                        <div class="floor-area-header"><span>Title</span><span>Gross Area (m<sup>2</sup>)</span><span></span></div>
                        <label class="floor-area-row fixed-floor-area-row"><span>Living Areas</span><input type="number" min="0" [ngModel]="building.livingAreasSqm" (ngModelChange)="setBuildingField(building, 'livingAreasSqm', $event)" [ngModelOptions]="{ standalone: true }" /><span class="floor-area-spacer"></span></label>
                        <label class="floor-area-row fixed-floor-area-row"><span>Outdoor Areas</span><input type="number" min="0" [ngModel]="building.outdoorAreasSqm" (ngModelChange)="setBuildingField(building, 'outdoorAreasSqm', $event)" [ngModelOptions]="{ standalone: true }" /><span class="floor-area-spacer"></span></label>
                        <label class="floor-area-row fixed-floor-area-row"><span>Car Areas</span><input type="number" min="0" [ngModel]="building.carAreasSqm" (ngModelChange)="setBuildingField(building, 'carAreasSqm', $event)" [ngModelOptions]="{ standalone: true }" /><span class="floor-area-spacer"></span></label>
                        <label class="floor-area-row fixed-floor-area-row"><span>Other Areas</span><input type="number" min="0" [ngModel]="building.otherAreasSqm" (ngModelChange)="setBuildingField(building, 'otherAreasSqm', $event)" [ngModelOptions]="{ standalone: true }" /><span class="floor-area-spacer"></span></label>
                        @for (floorArea of building.floorAreas; track floorArea.id; let floorAreaIndex = $index) {
                          <label class="floor-area-row dynamic-floor-area-row">
                            <div class="building-field-row"><input [ngModel]="floorArea.title" (ngModelChange)="setFloorAreaTitle(building, floorArea, $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openFloorAreaTitleOptions(building, floorAreaIndex)" aria-label="Pick floor area"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div>
                            <input type="number" min="0" [ngModel]="floorArea.grossArea" (ngModelChange)="setFloorAreaGrossArea(building, floorArea, $event)" [ngModelOptions]="{ standalone: true }" />
                            @if (!isCopyMode) { <button type="button" class="icon-outline-button floor-area-delete" (click)="removeFloorArea(building, floorAreaIndex)" aria-label="Delete floor area"><span class="trash-icon" aria-hidden="true"></span></button> } @else { <span class="floor-area-spacer"></span> }
                          </label>
                        }
                        @if (!isCopyMode) {
                          <button type="button" class="outline-button add-floor-area-button" (click)="addFloorArea(building)"><span class="plus-symbol" aria-hidden="true">+</span><span>Add Additional Floor Area</span></button>
                        }
                      </div>
                      <label><span>Total Floor Areas</span><input type="number" [value]="totalFloorAreas(building)" readonly aria-readonly="true" /></label>
                      <label><span>Internal Layout</span><div class="building-field-row"><input [ngModel]="building.internalLayout" (ngModelChange)="setBuildingField(building, 'internalLayout', $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, internalLayoutBuildingField)" aria-label="Pick Internal Layout"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      @if (job.reportType === 'Rural Report') {
                        <label><span>Internal Condition</span><div class="building-field-row"><input [ngModel]="building.internalCondition" (ngModelChange)="setBuildingField(building, 'internalCondition', $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, internalConditionBuildingField)" aria-label="Pick Internal Condition"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label><span>External Condition</span><div class="building-field-row"><input [ngModel]="building.externalCondition" (ngModelChange)="setBuildingField(building, 'externalCondition', $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, externalConditionBuildingField)" aria-label="Pick External Condition"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      }
                    </div>

                    <div class="additional-column">
                      <label><span>Year of Construction</span><div class="building-field-row year-building-field-row"><select [ngModel]="yearQualifierValue(building, 'yearOfConstruction')" (ngModelChange)="setBuildingYearQualifier(building, 'yearOfConstruction', $event)" [ngModelOptions]="{ standalone: true }"><option value="">--Select--</option>@for (qualifier of yearQualifiers; track qualifier) { <option [value]="qualifier">{{ qualifier }}</option> }</select><input [ngModel]="yearValue(building, 'yearOfConstruction')" (ngModelChange)="setBuildingYearValue(building, 'yearOfConstruction', $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, yearConstructionBuildingField)" aria-label="Pick Year of Construction"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      <label><span>Year Most Recent Additions Constructed</span><div class="building-field-row year-building-field-row"><select [ngModel]="yearQualifierValue(building, 'yearOfAdditions')" (ngModelChange)="setBuildingYearQualifier(building, 'yearOfAdditions', $event)" [ngModelOptions]="{ standalone: true }"><option value="">--Select--</option>@for (qualifier of yearQualifiers; track qualifier) { <option [value]="qualifier">{{ qualifier }}</option> }</select><input [ngModel]="yearValue(building, 'yearOfAdditions')" (ngModelChange)="setBuildingYearValue(building, 'yearOfAdditions', $event)" [ngModelOptions]="{ standalone: true }" />@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, yearAdditionsBuildingField)" aria-label="Pick Year Most Recent Additions Constructed"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      <label><span>Other Improvements (Significant Ancillary)</span><div class="building-field-row textarea-row"><textarea rows="4" [ngModel]="building.significantImprovements" (ngModelChange)="setBuildingField(building, 'significantImprovements', $event)" [ngModelOptions]="{ standalone: true }"></textarea>@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, significantImprovementsBuildingField)" aria-label="Pick Other Improvements Significant Ancillary"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      @if (job.reportType === 'Rural Report') {
                        <label><span>Other Improvements (Secondary Ancillary)</span><div class="building-field-row textarea-row"><textarea rows="4" [ngModel]="building.secondaryImprovements" (ngModelChange)="setBuildingField(building, 'secondaryImprovements', $event)" [ngModelOptions]="{ standalone: true }"></textarea>@if (!isCopyMode) { <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, secondaryImprovementsBuildingField)" aria-label="Pick Other Improvements Secondary Ancillary"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      }
                    </div>
                  </div>
                </section>
              </div>
            }
          </article>
        } @empty {
          <div class="empty-state dwellings-empty">
            <h3>No Main Dwelling Added</h3>
            <p>Main dwelling details are not available for this job</p>
            @if (isMultiDwellingValuationType) {
              <button type="button" class="action-button primary-action" (click)="addBuilding()"><span class="plus-symbol" aria-hidden="true">+</span><span>Add Dwelling</span></button>
            }
          </div>
        }

        @if (job.reportType != null) {
          <div class="section-divider"></div>
          @if (job.reportType === 'Rural Report') {
            <div class="section-heading rural-heading">
              <h2>Property Services and Improvements</h2>
            </div>
            <section class="dwelling-panel rural-panel" formGroupName="rural">
              <div class="field-grid rural-field-grid">
                @for (field of ruralFields; track field.key) {
                  <label>
                    <span>{{ field.label }}</span>
                    <div class="option-input">
                      <input [formControlName]="field.key" />
                      @if (field.optionList) {
                        <button type="button" class="icon-outline-button" (click)="openRuralOptions(field)" aria-label="Pick {{ field.label }}"><span class="button-icon list-icon" aria-hidden="true"></span></button>
                      }
                    </div>
                  </label>
                }
              </div>
              <div class="field-grid rural-field-grid" style="padding-top:18px">
                <label>
                  <span>Essential Repair?</span>
                  <select formControlName="essentialRepairRequired" (change)="onEssentialRepairRequiredChange()">
                    @for (option of essentialRepairOptions; track option) {
                      <option [value]="option">{{ option || 'Select' }}</option>
                    }
                  </select>
                </label>
                @if (isEssentialRepairRequired) {
                  <label>
                    <span>Essential Repair Comments</span>
                    <div class="option-input">
                      <input formControlName="essentialRepairComments" />
                      <button type="button" class="icon-outline-button" (click)="openRuralOptions(essentialRepairCommentsField)" aria-label="Pick Essential Repair Comments"><span class="button-icon list-icon" aria-hidden="true"></span></button>
                    </div>
                  </label>
                }
              </div>
            </section>
          } @else {
            <div class="section-heading rural-heading">
              <h2>Essential Repairs</h2>
            </div>
            <section class="dwelling-panel rural-panel" formGroupName="rural">
              <div class="field-grid rural-field-grid" style="padding-top:18px">
                <label>
                  <span>Essential Repair?</span>
                  <select formControlName="essentialRepairRequired" (change)="onEssentialRepairRequiredChange()">
                    @for (option of essentialRepairOptions; track option) {
                      <option [value]="option">{{ option || 'Select' }}</option>
                    }
                  </select>
                </label>
                @if (isEssentialRepairRequired) {
                  <label>
                    <span>Essential Repair Comments</span>
                    <div class="option-input">
                      <input formControlName="essentialRepairComments" />
                      <button type="button" class="icon-outline-button" (click)="openRuralOptions(essentialRepairCommentsField)" aria-label="Pick Essential Repair Comments"><span class="button-icon list-icon" aria-hidden="true"></span></button>
                    </div>
                  </label>
                }
              </div>
            </section>
          }

          <div class="section-divider"></div>
          <div class="section-heading other-buildings-heading">
            <h2>Other Buildings</h2>
            <button type="button" class="action-button primary-action" (click)="addOtherBuilding()"><span class="plus-symbol" aria-hidden="true">+</span><span>Add Other Building</span></button>
          </div>
          @if (otherBuildings.length === 0) {
            <div class="empty-state other-buildings-empty">
              <span class="home-icon empty-home-icon" aria-hidden="true"></span>
              <h3>No Other Buildings Added</h3>
              <p>Click "Add Other Building" to add a building</p>
              <button type="button" class="action-button primary-action" (click)="addOtherBuilding()"><span class="plus-symbol" aria-hidden="true">+</span><span>Add Other Building</span></button>
            </div>
          } @else {
            @for (building of otherBuildings; track building.id; let index = $index) {
              <article class="dwelling-accordion other-building-accordion" [class.open]="activeOtherBuildingId === building.id">
                <div class="other-building-trigger-row">
                  <button type="button" class="dwelling-trigger other-building-trigger" (click)="toggleOtherBuilding(building.id)">
                    <span class="home-icon" aria-hidden="true"></span>
                    <span>{{ building.title || 'Other Building ' + (index + 1) }}</span>
                  </button>
                  <div class="other-building-actions">
                    <button type="button" class="outline-button compact-button" (click)="openCameraPopout()">Upload Photos</button>
                    <button type="button" class="danger-button compact-button" (click)="removeOtherBuilding(building.id)"><span class="trash-icon" aria-hidden="true"></span><span>Delete Building</span></button>
                  </div>
                  <button type="button" class="other-building-chevron" (click)="toggleOtherBuilding(building.id)" aria-label="Toggle other building"><span class="chevron-icon" aria-hidden="true"></span></button>
                </div>

                @if (activeOtherBuildingId === building.id) {
                  <div class="dwelling-content other-building-content">
                    <div class="other-building-grid">
                      <div class="other-building-column">
                        <label><span>Title</span><div class="building-field-row"><input [ngModel]="building.title" (ngModelChange)="setOtherBuildingField(building, 'title', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.title)" aria-label="Copy Title"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'title', 'Title', 'otherBuildingTitleOptions')" aria-label="Pick Title"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label><span>Area (m²)</span><input type="text" inputmode="decimal" maxlength="10" pattern="\d{0,7}(\.\d{0,2})?" [ngModel]="building.area" (input)="onOtherBuildingAreaInput(building, $event)" (blur)="formatOtherBuildingArea(building)" [ngModelOptions]="{ standalone: true }" placeholder="0.00" /></label>
                        <label><span>Foundations</span><div class="building-field-row"><input [ngModel]="building.foundations" (ngModelChange)="setOtherBuildingField(building, 'foundations', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.foundations)" aria-label="Copy Foundations"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'foundations', 'Foundations', 'otherBuildingFoundationsOptions')" aria-label="Pick Foundations"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label><span>Flooring</span><div class="building-field-row"><input [ngModel]="building.flooring" (ngModelChange)="setOtherBuildingField(building, 'flooring', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.flooring)" aria-label="Copy Flooring"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'flooring', 'Flooring', 'otherBuildingFlooringOptions')" aria-label="Pick Flooring"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label><span>Walls</span><div class="building-field-row"><input [ngModel]="building.walls" (ngModelChange)="setOtherBuildingField(building, 'walls', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.walls)" aria-label="Copy Walls"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'walls', 'Walls', 'otherBuildingWallsOptions')" aria-label="Pick Walls"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label><span>Roof</span><div class="building-field-row"><input [ngModel]="building.roof" (ngModelChange)="setOtherBuildingField(building, 'roof', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.roof)" aria-label="Copy Roof"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'roof', 'Roof', 'otherBuildingRoofOptions')" aria-label="Pick Roof"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                      </div>
                      <div class="other-building-column">
                        <label><span>PC Items</span><div class="building-field-row"><input [ngModel]="building.pcItems" (ngModelChange)="setOtherBuildingField(building, 'pcItems', $event)" [ngModelOptions]="{ standalone: true }" />@if (isCopyMode) { <button type="button" class="icon-outline-button" (click)="copyField(building.pcItems)" aria-label="Copy PC Items"><span class="button-icon copy-icon" aria-hidden="true"></span></button> } @else { <button type="button" class="icon-outline-button" (click)="openOtherBuildingOptions(building, 'pcItems', 'PC Items', 'otherBuildingPcItemsOptions')" aria-label="Pick PC Items"><span class="button-icon list-icon" aria-hidden="true"></span></button> }</div></label>
                        <label class="other-building-notes"><span>Notes</span><textarea rows="5" maxlength="300" [ngModel]="building.notes" (ngModelChange)="setOtherBuildingField(building, 'notes', $event)" [ngModelOptions]="{ standalone: true }" placeholder="Enter notes (max 300 characters)"></textarea><small>{{ building.notes.length }}/300</small></label>
                      </div>
                    </div>
                  </div>
                }
              </article>
            }
          }
        }
      </section>
    }

    <ng-template #buildingFieldGrid let-building="building" let-fields="fields" let-gridClass="gridClass">
      <div class="building-field-grid" [class.external-building-grid]="gridClass === 'external-building-grid'" [class.internal-building-grid]="gridClass === 'internal-building-grid'">
        @for (field of fields; track field.key) {
          <label [class.wide]="field.kind === 'textarea'" [class.large-text-field]="field.kind === 'textarea'">
            <span>{{ field.label }}</span>
            <div class="building-field-row">
              @if (field.kind === 'textarea') {
                <textarea rows="6" [ngModel]="buildingFieldValue(building, field.key)" (ngModelChange)="setBuildingField(building, field.key, $event)" [ngModelOptions]="{ standalone: true }"></textarea>
              } @else {
                <input [type]="field.kind === 'number' ? 'number' : 'text'" min="0" [ngModel]="buildingFieldValue(building, field.key)" (ngModelChange)="setBuildingField(building, field.key, $event)" [ngModelOptions]="{ standalone: true }" />
              }
              @if (isCopyMode) {
                <button type="button" class="icon-outline-button" (click)="copyField(buildingFieldValue(building, field.key))" aria-label="Copy {{ field.label }}"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
              } @else if (field.optionList) {
                <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, field)" aria-label="Pick {{ field.label }}"><span class="button-icon list-icon" aria-hidden="true"></span></button>
              }
            </div>
          </label>
        }
      </div>
    </ng-template>

    <ng-template #buildingFieldList let-building="building" let-fields="fields">
      @for (field of fields; track field.key) {
        <label [class.wide]="field.kind === 'textarea'" [class.large-text-field]="field.kind === 'textarea'">
          <span>{{ field.label }}</span>
          <div class="building-field-row">
            @if (field.kind === 'textarea') {
              <textarea rows="6" [ngModel]="buildingFieldValue(building, field.key)" (ngModelChange)="setBuildingField(building, field.key, $event)" [ngModelOptions]="{ standalone: true }"></textarea>
            } @else {
              <input [type]="field.kind === 'number' ? 'number' : 'text'" min="0" [ngModel]="buildingFieldValue(building, field.key)" (ngModelChange)="setBuildingField(building, field.key, $event)" [ngModelOptions]="{ standalone: true }" />
            }
            @if (isCopyMode) {
              <button type="button" class="icon-outline-button" (click)="copyField(buildingFieldValue(building, field.key))" aria-label="Copy {{ field.label }}"><span class="button-icon copy-icon" aria-hidden="true"></span></button>
            } @else if (field.optionList) {
              <button type="button" class="icon-outline-button" (click)="openBuildingOptions(building, field)" aria-label="Pick {{ field.label }}"><span class="button-icon list-icon" aria-hidden="true"></span></button>
            }
          </div>
        </label>
      }
    </ng-template>

    @if (activeTab === 'notes') {
      <section class="tab-panel notes-panel">
        <div class="notes-mode-toolbar" role="group" aria-label="Notes mode">
          <button type="button" class="notes-mode-button" [class.active-mode]="notesMode === 'text'" (click)="setNotesMode('text')"><span class="button-icon text-note-icon" aria-hidden="true"></span><span>Text Notes</span></button>
          <button type="button" class="notes-mode-button" [class.active-mode]="notesMode === 'drawing'" (click)="setNotesMode('drawing')"><svg class="drawing-note-svg" viewBox="0 0 64 64" aria-hidden="true" focusable="false"><path d="M38.5 2.8a7.8 7.8 0 0 1 11 0l11.7 11.7a7.8 7.8 0 0 1 0 11L49.6 37.1a4.4 4.4 0 0 1-6.2 0L26.9 20.6a4.4 4.4 0 0 1 0-6.2L38.5 2.8Z"/><path d="M24.1 22.6 46 44.5c1.2 1.2 1.5 3 .7 4.5a39 39 0 0 0-4.2 12.6 3.4 3.4 0 0 1-2.5 2.9L5.6 73.7c-2.9.8-5.5-1.9-4.7-4.7l9.2-34.4a3.4 3.4 0 0 1 2.9-2.5 39 39 0 0 0 12.6-4.2c1.5-.8 3.3-.5 4.5.7Z" transform="translate(0 -10)"/><path d="M11.2 53.8 25.4 39.6a7.4 7.4 0 1 1 4.8 4.8L16 58.6a3.4 3.4 0 0 1-4.8 0 3.4 3.4 0 0 1 0-4.8Z" fill="#fff"/></svg><span>Drawing Notes</span></button>
        </div>
        @if (notesMode === 'text') {
          <label class="wide notes-text-field"><span>Notes</span><textarea rows="12" formControlName="notes"></textarea></label>
        } @else {
          <div class="notes-drawing-header">
            <p>Use this area to draw simple diagrams or make sketches related to the property</p>
            <button type="button" class="notes-clear-button" (click)="clearDrawing()"><span class="button-icon trash-icon" aria-hidden="true"></span><span>Clear</span></button>
          </div>
          <canvas
            #drawingCanvas
            width="900"
            height="420"
            class="drawing-canvas"
            (pointerdown)="startDrawing($event)"
            (pointermove)="draw($event)"
            (pointerup)="stopDrawing()"
            (pointerleave)="stopDrawing()"></canvas>
        }
      </section>
    }
  </form>

  <ng-template #fieldGrid let-fields="fields">
    <div class="field-grid">
      @for (field of fields; track field.key) {
        <label [class.wide]="field.kind === 'textarea'">
          <span>{{ field.label }}</span>
          @if (field.kind === 'textarea') {
            <textarea [formControlName]="field.key" rows="4"></textarea>
          } @else if (field.kind === 'number') {
            <input type="number" [formControlName]="field.key" />
          } @else if (field.kind === 'option') {
            <div class="option-input">
              <input [formControlName]="field.key" readonly />
              <button type="button" class="btn secondary" (click)="openOptions(field)">Pick</button>
            </div>
          } @else {
            <input [type]="field.kind === 'year' ? 'text' : 'text'" [formControlName]="field.key" />
          }
        </label>
      }
    </div>
  </ng-template>

  <app-job-form-modal
    [open]="showEditJobModal"
    [job]="job"
    (closed)="showEditJobModal = false"
    (saved)="showEditJobModal = false; load()"
    (prefill)="patchForm($event)" />

  <app-option-modal
    [open]="optionModal.open"
    [title]="optionModal.title"
    [options]="optionModal.options"
    [optionGroups]="optionModal.optionGroups"
    [currentValue]="optionModal.currentValue"
    [singleSelect]="optionModal.singleSelect"
    [hint]="optionModal.hint"
    (closed)="optionModal.open = false"
    (applied)="applyOption($event)" />

  <app-internal-description-quick-choice
    [open]="internalDescQuickChoiceModal.open"
    title="Internal Description"
    [values]="internalDescQuickChoiceModal.values"
    [finishSeed]="internalDescQuickChoiceModal.finishSeed"
    (closed)="closeInternalDescriptionQuickChoice()"
    (applied)="applyInternalDescriptionQuickChoice($event)"
    (copyToImprovements)="applyInternalDescriptionFinish($event)" />

  @if (quickSelectModal.open) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel quick-select-panel" role="dialog" aria-modal="true" [attr.aria-label]="quickSelectModal.title">
        <header class="modal-header quick-select-header">
          <div>
            <h2>{{ quickSelectModal.title }}</h2>
            <p>{{ quickSelectModal.description }}</p>
          </div>
          <button type="button" class="icon-close quick-close" (click)="closeQuickSelect()" aria-label="Close">x</button>
        </header>

        <div class="quick-select-body">
          @for (group of quickSelectModal.groups; track group.key) {
            <section class="quick-group">
              <h3>{{ group.label }} @if (group.singleSelect) { <span>(single selection)</span> }</h3>
              <div class="quick-option-grid">
                @for (option of group.options; track option) {
                  <button type="button" class="quick-option" [class.selected]="quickOptionSelected(group, option)" (click)="toggleQuickOption(group, option)">{{ option }}</button>
                }
              </div>
            </section>
          }
        </div>

        <footer class="modal-footer quick-select-footer">
          <button type="button" class="outline-button" (click)="closeQuickSelect()">Cancel</button>
          <button type="button" class="action-button primary-action" (click)="applyQuickSelect()">Apply All</button>
        </footer>
      </section>
    </div>
  }

  @if (appointmentPicker.open) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel appointment-picker-panel" role="dialog" aria-modal="true" aria-label="Select appointment date and time">
        <header class="appointment-picker-header">
          <h2>Appointment</h2>
          <button type="button" class="year-close" (click)="closeAppointmentPicker()" aria-label="Close">x</button>
        </header>

        <div class="appointment-picker-body">
          <section class="appointment-calendar" aria-label="Appointment date">
            <div class="appointment-month-row">
              <button type="button" class="appointment-month-button" (click)="changeAppointmentMonth(-1)" aria-label="Previous month">&lsaquo;</button>
              <h3>{{ appointmentMonthLabel() }}</h3>
              <button type="button" class="appointment-month-button" (click)="changeAppointmentMonth(1)" aria-label="Next month">&rsaquo;</button>
            </div>

            <div class="appointment-weekdays">
              @for (weekday of appointmentWeekdays; track weekday) {
                <span>{{ weekday }}</span>
              }
            </div>

            <div class="appointment-day-grid">
              @for (day of appointmentCalendarDays(); track day.date.toISOString()) {
                <button
                  type="button"
                  class="appointment-day"
                  [class.outside-month]="!day.currentMonth"
                  [class.today]="isTodayAppointmentDate(day.date)"
                  [class.selected]="isSelectedAppointmentDate(day.date)"
                  (click)="selectAppointmentDate(day.date)">
                  {{ day.day }}
                </button>
              }
            </div>
          </section>

          <section class="appointment-time-panel" aria-label="Appointment time">
            <h3>Time</h3>
            <div class="appointment-time-list">
              @for (time of appointmentTimes; track time) {
                <button type="button" class="appointment-time" [class.selected]="appointmentPicker.selectedTime === time" (click)="selectAppointmentTime(time)">{{ time }}</button>
              }
            </div>
          </section>
        </div>

        <footer class="appointment-picker-footer">
          <button type="button" class="outline-button" (click)="selectAppointmentToday()">Today</button>
          <button type="button" class="outline-button" (click)="selectAppointmentTimeNow()">Time Now</button>
          <button type="button" class="action-button primary-action" [disabled]="!appointmentPicker.selectedDate" (click)="applyAppointmentPicker()">Done</button>
        </footer>
      </section>
    </div>
  }

  @if (yearPickerModal.open) {
    <div class="modal-backdrop" role="presentation">
      <section class="modal-panel year-picker-panel" role="dialog" aria-modal="true" [attr.aria-label]="yearPickerModal.title">
        <header class="year-picker-header">
          <h2>{{ yearPickerModal.title }}</h2>
          <button type="button" class="year-close" (click)="closeYearPicker()" aria-label="Close">x</button>
        </header>

        <div class="year-picker-body">
          <div class="year-button-grid qualifier-grid">
            @for (qualifier of yearQualifiers; track qualifier) {
              <button type="button" class="year-choice qualifier-choice" [class.selected]="yearPickerModal.selectedQualifier === qualifier" (click)="toggleYearQualifier(qualifier)">{{ qualifier }}</button>
            }
          </div>

          <div class="year-button-grid decade-grid">
            @for (decade of yearDecades; track decade) {
              <button type="button" class="year-choice" [class.selected]="yearPickerModal.selectedDecade === decade" (click)="toggleYearDecade(decade)">{{ decade }}</button>
            }
          </div>

          @if (yearPickerModal.selectedDecade) {
            <div class="year-button-grid single-year-grid">
              @for (year of selectedDecadeYears; track year) {
                <button type="button" class="year-choice" [class.selected]="yearPickerModal.selectedYear === '' + year" (click)="toggleYear(year)">{{ year }}</button>
              }
            </div>
          }
        </div>

        <footer class="year-picker-footer">
          <button type="button" class="action-button primary-action" [disabled]="!yearPickerModal.selectedYear" (click)="applyYearPicker()">Use Selected</button>
          <button type="button" class="outline-button" (click)="closeYearPicker()">Close</button>
        </footer>
      </section>
    </div>
  }
}
